module.exports = __webpack_public_path__ + "static/media/icon-users-desktop.e86b32f7.svg";